import { FC } from 'react';
import { ActionFeedV2 } from './components/action-feed-v2';

export const ActionFeedPageV2: FC = () => {
    return (
        <>
            <ActionFeedPageV2Component />
        </>
    );
};

const ActionFeedPageV2Component: FC = () => {
    return <ActionFeedV2 />;
};
